import React, { useEffect, useState, useCallback }  from 'react';
import { motion } from "framer-motion";
import "./index.scss";

import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getTopTechnologies } from "../../../../../../store/actions/thirdPartyRiskAction";
import { formatNumber, getTechnologiesImageUrl } from "../../../../../../utils/util";
import NoDataFound from "../../../../../ui/NoDataFound";

const TopTechnologies = ()=>{

    const topTechnologiesResponse = useSelector((state) => state.thirdPartyRisk.topTechnologiesStats);

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [topTechnologiesLoading, setTopTechnologiesLoading] = useState(false);
    const [technologiesList, setTechnologiesList] = useState(null);

    const getProfileImage = (data) => {       
        const obj  = {
            name : data.replace(/\//g, '')
        }
        return getTechnologiesImageUrl(obj);        
    }

    const fetchTopTechnologies = useCallback(()=>{
        setTopTechnologiesLoading(true);
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getTopTechnologies(params))
    },[organizationId, domainId, scanId, dispatch])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchTopTechnologies();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchTopTechnologies])

    useEffect(()=>{
        if(topTechnologiesResponse !== null) {
            setTopTechnologiesLoading(false);
            setTechnologiesList(topTechnologiesResponse);
        }
    },[topTechnologiesResponse])

    return (
        <div className="bg-white-with-shadow p-4 h-100 mt-4">
            {
                topTechnologiesLoading ?
                <SkeletonLoader type={"line"} count={7} currentPage={"digitalfootprint"} />
                :
                <motion.div
                    className="h-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="top-technologies-container">
                        <h4 className="top-technology-heading">Top Technologies</h4>
                        {
                            technologiesList?.stats?.domain_top_technologies?.technologies && Object.entries(technologiesList?.stats?.domain_top_technologies?.technologies).length > 0 ?
                                <div className="technologies-list-container">
                                {
                                    technologiesList?.stats?.domain_top_technologies?.technologies && Object.entries(technologiesList?.stats?.domain_top_technologies?.technologies).length > 0 && 
                                    Object.entries(technologiesList?.stats?.domain_top_technologies?.technologies).map(([key, value], index) => {
                                        if(index < 10) {
                                            return (
                                                <div className="technology-container d-flex align-items-center justify-content-between p-3" key={index}>
                                                    <div className="technology-name d-flex align-items-center gap-2">
                                                        <div className="technology-image">
                                                            <img src={getProfileImage(key)} alt="technology name"/>
                                                        </div>
                                                        <p>{key}</p>
                                                    </div>
                                                    <div className="technology-usage">
                                                        <p className="usage-count">{formatNumber(value)}</p>
                                                        <p className="usage-text">Usage</p>
                                                    </div>
                                                </div>
                                            )    
                                        }
                                        return null
                                    })
                                }
                            </div>                        
                        :
                        <NoDataFound noDataText={technologiesList?.description} />
                        }
                    </div>
                </motion.div>
            }
        </div>
    )
}

export default TopTechnologies;